import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import Cart from '../component/Cart';

function CartContainer() {
    return <Cart />;
}

const mapStateToProps = (state: { verify: unknown }) => ({
    verify: state.verify,
});

export default compose(connect(mapStateToProps), withRouter)(CartContainer);
